import React from 'react';
import logo from '../../logos/dysun_cropped.jpeg';


function Header() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <img src={logo} alt="Logo" className="logo" />
      <nav>
        <ul>
          <li><button onClick={() => scrollToSection('solution')}>Solution</button></li>
          <li><button onClick={() => scrollToSection('features')}>Features</button></li>
          <li><button onClick={() => scrollToSection('founder')}>About</button></li>
          <li><button onClick={() => scrollToSection('get-in-touch')}>Contact</button></li>
          <li><button onClick={() => scrollToSection('faqs')}>FAQs</button></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;